import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { ShopLandingPage as UIShopLandingPage } from "./shop-landing-page/ShopLandingPage";

import type { shopLandingPageInputs } from "./ShopLandingPage.builder";

type ShopLandingPageBuilderProps = BuilderComponentProps<typeof shopLandingPageInputs>;

export const ShopLandingPage: FC<ShopLandingPageBuilderProps> = ({ title, subtitle, shopPageTeasers }) => {
  const mappedTeasers = (shopPageTeasers ?? []).map((teaser) => ({
    title: teaser.title,
    path: teaser.path,
    backgroundImage: teaser.backgroundImage,
    relatedLanguage: teaser.relatedLanguage ?? "",
  }));

  return (
    <UIShopLandingPage
      isInEditor={isEditing()}
      title={title}
      subtitle={subtitle ?? ""}
      shopPageTeasers={mappedTeasers}
    />
  );
};
